<template>
  <v-speed-dial v-model="fab" direction="right" right>
    <template v-slot:activator>
      <v-btn v-model="fab" icon>
        <v-icon v-if="fab">mdi-close</v-icon>
        <v-icon v-else>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <!--    :disabled="item.status === 'success'" -->
    <v-btn class="ma-0 rounded-pill" color="success" depressed fab small
           title="ارتقا" @click="$emit('click')">
      <v-icon>mdi-currency-usd</v-icon>
    </v-btn>
  </v-speed-dial>
</template>

<script>
export default {
  name: "autoPayButtons",

  props: {
    item: Object
  },

  data() {
    return {
      fab: false,
    }
  }
}
</script>

<style scoped>

</style>